import ErrorBoundary from "@COMPONENTS/common/error/ErrorBoundary";
import {
	FlagGoodsBrandCd,
	FlagGoodsCd,
	FlagGoodsTmember,
	FlagGoodsTp,
	FlagPromotion,
	FlagYellowPangdeal,
	FlagYellowPick,
} from "@COMPONENTS/common/flag/Mobile";
import {hashTagManufacture} from "@COMPONENTS/common/goodsUtil";
import * as style from "@COMPONENTS/style/productlist/productlistM";
import {ShareButton} from "@FRAMEWORK/ui/mobile/button";
import {Flex} from "@FRAMEWORK/ui/mobile/layout";
import ProductListThumbnail from "@FRAMEWORK/ui/mobile/thumbnail/ProductListThumbnail";
import {GoodsByMenu} from "@QUERIES/prdt/goods/useGoodsByMenu";
import {Noimage} from "@yb/ui/mobile/common/Noimage";
import {useRouter} from "next/router";
import React from "react";

interface Props {
	selectedProduct: string[];
	selectToCompare: (e: React.ChangeEvent<HTMLInputElement>) => void;
	product: GoodsByMenu;
	handleShare: (goodsCd: string) => void;
}

const LocalThumbnailComponent = ({selectedProduct, selectToCompare, product, handleShare}: Props) => {
	const router = useRouter();
	const {menu, dspSid} = router.query;

	if (!menu || !dspSid) {
		return <></>;
	}

	return (
		<ProductListThumbnail>
			<style.ImageItem>
				<Noimage width="100%" height="200px" src={product.imageThum3} alt="상품 이미지" />
			</style.ImageItem>
			<style.ProductCheck
				type="checkbox"
				checked={selectedProduct.some(value => value === product.goodsCd)}
				onChange={selectToCompare}
				value={product.goodsCd}
			/>
			<style.CircleButtonWrap>
				<FlagYellowPick pickYn={product.pickYn} />
				<FlagYellowPangdeal ypdYn={product.ypdYn} />
				<FlagPromotion goodsCd={product.goodsCd} />
			</style.CircleButtonWrap>
			{/* 태그 및 점수 */}
			<style.StackWrap>
				<p>{hashTagManufacture(product.keyWordList, 3)}</p>
				<Flex>
					<style.StarImg />
					<em>{product.rvwAvgScore || "-"}</em>/ 5
					<ShareButton onClick={() => handleShare(product.goodsCd)}>
						<span>공유하기</span>
					</ShareButton>
				</Flex>
			</style.StackWrap>
			{/* 상품 설명 태그 */}
			<style.TagGroup>
				<FlagGoodsCd goodsCd={product.goodsCd} />
				<FlagGoodsTp goodsTp={product.goodsTp} />
				<FlagGoodsBrandCd goodsBrandCd={product.goodsBrandCd} />
				<FlagGoodsTmember goodsTmember={product.goodsTmember} />
			</style.TagGroup>
		</ProductListThumbnail>
	);
};

const LocalThumbnail = (props: Props) => (
	<ErrorBoundary logMsg="Product Thumbnail Error">
		<LocalThumbnailComponent {...props} />
	</ErrorBoundary>
);

export default LocalThumbnail;
